import SecondaryVideosView from './SecondaryVideosView';

export default SecondaryVideosView;
